import React, { useState, useRef } from 'react';
import { RequestOpenAxios } from '../APIUtils';

const PasswordReset = () => {
  const [rsemail, setRsemail] = useState('');
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [msg, setMsg] = useState('');
  const [success, setSuccess] = useState(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRsemail(event.target.value);
  };

  const submitResetRequest = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (buttonRef.current) {
      buttonRef.current.disabled = true;
    }

    const options = {
      url: '/auth/resetpassword',
      method: 'POST',
      params: {
        email: rsemail,
      },
    };

    RequestOpenAxios(options).then((res) => {
      if (buttonRef.current) {
        buttonRef.current.disabled = false;
      }
      setMsg(res.data.message);
      setSuccess(res.data.success);
    });
  };

  return (
    <div>
      {success ? (
        <div className="text-red-600">{msg}</div>
      ) : (
        <form>
          <div className="mb-4">
            <label htmlFor="resetEmail" className="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <input
              type="email"
              id="resetEmail"
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Email to Reset Password"
              onChange={handleInputChange}
            />
            <small className="text-red-600 font-bold">Enter email address to Reset Password.</small>
          </div>

          <button
            type="submit"
            onClick={submitResetRequest}
            ref={buttonRef}
            className="border border-red-600 text-red-600 px-4 py-2 rounded text-sm"
          >
            Submit Password Reset Request
          </button>
        </form>
      )}
    </div>
  );
};

export default PasswordReset;